import { ReactComponent as OwnOperationIcon } from 'assets/icons/factory.svg';
import { ReactComponent as SupplierIcon } from 'assets/icons/warehouse.svg';
import { VALUE_CHAIN_UNIT_TYPES } from 'constants/interfaces';

const renderUnitIcon = (type: string) => (
  type === VALUE_CHAIN_UNIT_TYPES.BALANCE_SHEET_ASSET ? <OwnOperationIcon /> : <SupplierIcon />
);

export default renderUnitIcon;
